import Promise from 'bluebird';
import { useEffect } from 'react';
import _ from 'underscore';

import { useAction } from './hooks/use-data-actions';
import { useCache } from './context/cache-context';

import { getCCJsDataObj } from './ccui-util';
import type {
  CCDataServerContext,
  CCJsDataRepositories,
  EntityId,
  TopUpLimit,
} from './types';

class TopUpLimitActions {
  aid: EntityId;
  cid: EntityId;
  jsDataCcRest: CCJsDataRepositories;

  constructor({
    CurrentAccount,
    CurrentCustomer,
    CurrentUser
  }: CCDataServerContext) {
    this.aid = CurrentAccount && CurrentAccount.Id;
    this.cid = CurrentCustomer && CurrentCustomer.Id;
    const uid = CurrentUser && CurrentUser.Id;

    this.jsDataCcRest = getCCJsDataObj(this.cid, uid);
  }

  fetchAll = () => Promise.resolve(this.jsDataCcRest.TopUpLimit.findAll(
    { customerId: this.cid, accountId: this.aid },
    { bypassCache: true }
  ));
}

export const useTopUpLimit = (serverContext: CCDataServerContext) => {
  const { cache, tryUpdate } = useCache<TopUpLimit[]>('topUpLimits');
  const domainActions = useAction(TopUpLimitActions, serverContext);

  useEffect(() => {
    if (_.isUndefined(cache) && domainActions) {
      tryUpdate(() => domainActions.fetchAll());
    }
  }, [domainActions, cache, tryUpdate]);

  return cache;
};
